import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import 'url-search-params-polyfill';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { HeaderComponent } from './header/header.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AuthGuard } from './shared/guards/auth.guard';
import { PublicGuard } from './shared/guards/public.gaurd';
import { AppConfig } from './app.config';
import { SharedModule } from './shared/shared.module';
import { LoaderService } from './shared/loader/loader.service';
import { PrivateComponent } from './layout/private/private.component';
import { PublicComponent } from './layout/public/public.component';  
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlashMessagesModule } from './shared/flash-messages/flash-messages.module';
import { MaterialCommonModule } from './shared/material-common/material-common.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { SearchComponent } from './search/search.component';
@NgModule({
  declarations: [
    AppComponent,
    PublicComponent,
    PrivateComponent,
    HeaderComponent,
    NotFoundComponent,
    SearchComponent
    
  ],
  
  imports: [
    BrowserAnimationsModule,
    ModalModule.forRoot(),
    BrowserModule,
    HttpModule,
    SharedModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BsDropdownModule.forRoot(), 
    FlashMessagesModule,
    MaterialCommonModule,
    
  ],
  providers: [
    LoaderService,
    AppConfig,
    AuthGuard,
    PublicGuard,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
